import { Info } from 'lucide-react';

import { Alert, AlertDescription } from '@nesso/ui/primitives/alert';

import { formatShortDate, formatTime } from '@/shared/lib/time-utils';

type Props = {
    deletedAt: Date | string | null | undefined;
};

export function SessionNoteDeleted({ deletedAt }: Props) {
    const when = deletedAt ? `${formatShortDate(deletedAt)}, ${formatTime(deletedAt)}` : null;

    return (
        <Alert variant="accent">
            <Info className="size-4" />
            <AlertDescription>
                {when
                    ? `The AI-generated note was deleted ${when} and cannot be regenerated.`
                    : 'The AI-generated note was deleted and cannot be regenerated.'}
            </AlertDescription>
        </Alert>
    );
}
